<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goback()"></span>
    </div>
    
    <div class="title">请确认订单详情</div>

    <img class="prepay-img" src='../../assets/img/other/prepaid50.png'>

      <div class="weui-cells__title">预计价格（仅作参考，以实际服务为准）</div>

      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.labor_hour_cost">每小时{{pricing.labor_hour_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="pricing.stairs_cost">
            <div class="weui-cell__bd">
                <p>楼梯费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.stairs_cost">{{pricing.stairs_cost | numeral('$0,0.00')}} </span>
              <span v-if="pricing.stairs_cost==0">无</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>出车回程费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.return_trip_cost">约 {{pricing.return_trip_cost | numeral('$0,0.00')}}</div>
        </a>

        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>快递费用</p>
            </div>
            <div class="weui-cell__ft">
              <span>$13 / kg</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>GST费用</p>
            </div>
            <div class="weui-cell__ft">
              <span>总费用10%</span>
            </div>
        </a>
        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <p class="park-assist" @click="goto('/baggage-price')"> <span class="icon-info parking-icon"></span> 点击查看收费标准 </p>
            </div>
        </label>
      </div>

      <div class="weui-cells__title">服务详情，点击可修改</div>
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/baggage-step3')">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft">{{order.data.service_date | moment("YYYY年M月D日")}} {{service_period}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/baggage-step2/from')">
            <div class="weui-cell__bd">
                <p>联系信息</p>
            </div>
            <div class="weui-cell__ft">{{order.data.out_name}} {{order.data.out_phone}} <br>{{order.data.email}} </div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/baggage-step2/from')">
            <div class="weui-cell__bd">
                <p>寄件地址</p>
            </div>
            <div class="weui-cell__ft"><span v-show="order.data.out_unit">{{order.data.out_unit}}, </span>{{order.data.out_street}},<br> {{order.data.out_suburb}}, {{order.data.out_state}}, {{order.data.out_postcode}}</div>
        </a>
        <a  v-for="(item, index) in order.data.home_address" class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/baggage-step2/to-more?wpKey='+index)">
            <div class="weui-cell__bd">
                <p>收件地址 {{order.data.home_address.length>1 ? index+1 : ''}}</p>
            </div>
            <div class="weui-cell__ft">{{item.home_name}},{{item.home_phone}}<br> {{item.home_address}}</div>
        </a>

      </div>

      <div class="weui-cells__title">优惠券</div>
      <div class="weui-cells coupon-cell">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/coupon-apply')">
            <div class="weui-cell__bd">
                <p>优惠券</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.coupon_id">{{order.data.coupon_title | uppercase}}</div>
            <div class="weui-cell__ft" v-else> <span class="icon-coupon"></span> 点击使用 </div>
        </a>
      </div>

      <div class="weui-cells__title">留言备注</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <textarea class="weui-textarea" placeholder="如果有特殊需求，请在此备注留言" rows="2"  v-model="order.data.msg"></textarea>
              </div>
          </div>
      </div>

      <div class="weui-cells__title">中介推荐码</div>
      <div class="weui-cells">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <input class="weui-input" type="text" placeholder="如果由中介推荐，请输入中介推荐码" v-model="order.data.agency">
              </div>
          </div>
      </div>
      <br>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="ising=true">创建订单</div>
        </div>
      </div>
      <div class="js_dialog" v-show="ising">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">温馨提醒</strong></div>
              <div class="weui-dialog__bd">请确保服务信息无误，提交后信息将被锁定，只能联系客服修改</div>
              <div class="weui-dialog__ft">
                  <div  class="weui-dialog__btn weui-dialog__btn_default" @click="ising=false">关闭</div>
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="Order()">确定提交</div>
              </div>
          </div>
      </div>

      <transition name="fade">
          <div id="loadingToast" v-show="isSendingPricing">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取报价</p>
              </div>
          </div>
      </transition>
      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在提交</p>
              </div>
          </div>
      </transition>
      
      <img :src="pixelURL('move','xiadan')" class="hide">
    </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'finalStep',
  data () {
    return {
      order:{},
      isSending:false,
      isSendingPricing:false,
      pricing:{},
      ising:false,
    }
  },
  methods: {
    editData(url){
      localStorage.isEditing = '/baggage-step4';
      this.$router.push(url);
    },
    goback(){
      if(this.$route.query.src == 'order'){
        this.$router.push('/order');
      }
      else{
        this.$router.push('/baggage-step3');
      }
    },

    getPricing(){
      if(this.isSendingPricing){
        return false;
      }
      else{
        this.isSendingPricing = true;
        let that = this;

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        orderObject.type_id = 1550735905;

        orderObject.vehicle_type = 1551345549;
        orderObject.move_in_floor = this.dataLint("floor",orderObject.in_floor);
        orderObject.move_out_floor = this.dataLint("floor",orderObject.out_floor);
        orderObject.move_in_street = orderObject.in_street;
        orderObject.move_in_suburb = orderObject.in_suburb;
        orderObject.move_in_state = orderObject.in_state;
        orderObject.move_in_postcode = orderObject.in_postcode;
        if(orderObject.out_unit.length>0){
          orderObject.move_out_street = orderObject.out_unit+", "+orderObject.out_street;
        }
        else{
          orderObject.move_out_street = orderObject.out_street;
        }
        orderObject.move_out_suburb = orderObject.out_suburb;
        orderObject.move_out_state = orderObject.out_state;
        orderObject.move_out_postcode = orderObject.out_postcode;

        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Cost/getCost', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.pricing = response.data.data;
            that.isSendingPricing=false;
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSendingPricing=false;
          }
        })
        .catch(function (error) {
          alert("获取报价失败，请检查网络并尝试刷新页面")
          that.isSendingPricing=false;
          console.log(error);
        });
      }
    },


    Order(){
      this.ising = false;

      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        this.orderUpdate('agency',this.order.data.agency)
        this.orderUpdate('msg',this.order.data.msg)

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        orderObject.type_id = 1550735979;

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
            orderObject.member_name = localStorage.member_name;
            orderObject.member_phone = localStorage.member_phone;
            orderObject.member_mail = localStorage.member_mail;
        }
        else{
            orderObject.token = 0;
            orderObject.member_name = orderObject.out_name;
            orderObject.member_phone = orderObject.out_phone;
        }

        orderObject.service_date = new Date(orderObject.service_date);
        orderObject.service_date = Vue.filter('moment')(orderObject.service_date,"YYYY-MM-DD");

        orderObject.in_floor = this.dataLint("floor",orderObject.in_floor);
        orderObject.out_floor = this.dataLint("floor",orderObject.out_floor);
        orderObject.in_parking = this.dataLint("parking",orderObject.in_parking);
        orderObject.out_parking = this.dataLint("parking",orderObject.out_parking);


        orderObject['vehicle_type'] = 1551345549;
        
        orderObject['order_source'] = '3';

        //     途经点floor parking数据备用
        //     for (var i=0;i<orderObject.pathway_address.length;i++){
        //       orderObject.pathway_address[i].move_wp_floor = this.dataLint("floor",orderObject.pathway_address[i].move_wp_floor);
        //       orderObject.pathway_address[i].move_wp_parking = this.dataLint("parking",orderObject.pathway_address[i].move_wp_parking);
        //     }

        if(orderObject.out_unit.length>0){
          orderObject.out_street = orderObject.out_unit+", "+orderObject.out_street;
        }
        else{
          orderObject.out_street = orderObject.out_street;
        }

        this.axios.post(this.apiURL()+'/Order/createOrder', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            localStorage.removeItem('order');

            localStorage.is_questions = response.data.data.is_questions;
            localStorage.phone_question = orderObject.member_phone;
            localStorage.questions = JSON.stringify(response.data.data.questions);
            

            if(response.data.data.accoun_status>=0){
              localStorage.account_status = response.data.data.accoun_status;
            }

            if(response.data.data.accoun_status == 2){
              localStorage.token = response.data.data.token;
              localStorage.member_phone = response.data.data.phone;
              localStorage.member_name = response.data.data.name;
              localStorage.tempPasswd = response.data.data.password;
            }
            
            that.$router.push('/order-prepay?id='+response.data.data.order_number+'&status=0&amount='+that.depositAmount());

          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });

      }
    },
    dataLint(name,value){
      let result ="";


      if (name == "parking") {
        switch (value) {
          case "1":
            result = "1551410080"
            break;
          case "2":
            result = "1551410087"
            break;
          case "3":
            result = "1551410093"
            break;
          default:
            console.log("6");
        }
      }

      if (name == "floor") {
        switch (value) {
          case "1":
            result = "1551412462"
            break;
          case "2":
            result = "1551412475"
            break;
          case "3":
            result = "1551412486"
            break;
          case "4":
            result = "1551412499"
            break;
          case "5":
            result = "1551412509"
            break;
          case "6":
            result = "1551412525"
            break;
          case "7":
            result = "1551412535"
            break;
          default:
            console.log("7");
        }
      }
      return result;
    },

    toTextParking(theVar){
      let result = '';
      switch (theVar) {
        case "1":
          result = '已预留Loading Dock'
          break;
        case "2":
          result = '已预留停车位'
          break;
        case "3":
          result = '无停车位'
          break;
        default:
          console.log("9");
      }
      return result;
    },
    toTextFloor(theVar){
      let result = '';
      switch (theVar) {
        case "1":
          result = '有电梯/住G层'
          break;
        case "2":
          result = '1层 无电梯'
          break;
        case "3":
          result = '2层 无电梯'
          break;
        case "4":
          result = '3层 无电梯'
          break;
        case "5":
          result = '4层 无电梯'
          break;
        case "6":
          result = '5层 无电梯'
          break;
        case "7":
          result = '5层以上 无电梯'
          break;
        default:
          console.log("8");
      }
      return result;
    },
  },
  components: {
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.order.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
  },
  created: function () {

    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "baggage"){
        this.order = localParsed;
        this.userCatch("1550735979",this.order.data.out_name,this.order.data.out_phone,true);
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
    this.getPricing();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell__ft{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:70%;
  font-size:0.9em;
}

.mini-title{
  margin-top:20px;
  color: #595D68;
  font-size: 12pt;
  text-align: center;
  font-weight: bold;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.prepay-img{
  width:100%;
}

.container /deep/{

  .couponPd{
    padding-top:0;
    padding-bottom:0;
  }

  .weui-vcode-btn{
    padding-right:0;
    margin-left:10px;
    color:#ff7444;
  }
  .weui-cell_access .weui-cell__ft:after{
    border-color: #FE956A;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/baggage/step4.vue